/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import { KTSVG, toAbsoluteUrl } from '../../../helpers'
import { Rating } from '../../content/Rating'
import { DropdownFilterDate } from '../../content/dropdown/DropdownFilterDate'
import { LanguageHelp } from '../../../helpers/LanguageHelper'
import { DropdownFilterSubject } from '../../content/dropdown/DropdownFilterSubject'
import { DropdownFilterChannels } from '../../content/dropdown/DropdownFilterChannels'
import { DropdownFilterCompetitor } from '../../content/dropdown/DropdownFilterCompetitor'
type Props = {
  className: string
  datas?: TablesWidget5Dto
  firstColor?: string
  secondColor?: string
  thirdColor?: string
  mainLabel?: string
  sideLabel?: string
  functionSubmit?: any
  functionDownload?: any
  isDownloadContinue?: boolean
  options?: string[]
  selectedOption?: string
  selectedChannelType?: string
  selectedDate?: string
  competitors?: string[]
  selectedCompetitor?: string
}

export class TablesWidget5ItemDto { label = ""; firstCount = 0; secondCount = 0; thirdCount = 0; fourthCount = 0; firstRate = 0; secondRate = 0; thirdRate = 0; fourthRate = 0; image = ""; url = ""; type = 1; isCompetitor = false }

export class TablesWidget5Dto { items: TablesWidget5ItemDto[] = [new TablesWidget5ItemDto]; totalCount = 0; totalRate = 0; }

const TablesWidget5: React.FC<Props> = ({
  className,
  datas = new TablesWidget5Dto(),
  mainLabel = "Your Statistics",
  sideLabel = "",
  functionSubmit,
  functionDownload,
  isDownloadContinue = false,
  options = [],
  selectedOption = LanguageHelp('All'),
  selectedChannelType = LanguageHelp('All Platforms'),
  selectedDate = LanguageHelp('Last 30 days'),
  competitors = [],
  selectedCompetitor = LanguageHelp('All Competitors'),
}) => {

  return (
    <div className={`card ${className}`}>
      {/* begin::Header */}
      <div className='card-header pt-5'>
        <div className='card-title align-items-start flex-column'>
          <span className='card-label fw-bold text-dark'>{mainLabel}</span>
          <div>
            <span className='text-gray-400 fw-semibold fs-6 me-1'>{sideLabel}:</span>
            {datas.totalCount !== 0 &&
              <div style={{ display: 'inline-flex' }}>
                <span className='card-label fw-bolder text-gray-700 mt-1'> {datas.totalCount}</span>
                <Rating rate={datas.totalRate} />
              </div>
            }
          </div>
        </div>
        <div className='card-toolbar'>
          <DropdownFilterCompetitor className='me-2 mb-2' functionSubmit={functionSubmit} options={competitors} selectedOption={selectedCompetitor} />
          <DropdownFilterSubject className='me-2 mb-2' functionSubmit={functionSubmit} options={options} selectedOption={selectedOption} />
          <DropdownFilterChannels className='me-2 mb-2' functionSubmit={functionSubmit} selectedChannelType={selectedChannelType} />
          <DropdownFilterDate className='me-2 mb-2' functionSubmit={functionSubmit} selectedDate={selectedDate} />
          <button
            type='button'
            className='btn btn-sm btn-icon btn-bg-light btn-active-color-primary mb-2'
            data-kt-menu-trigger='click'
            data-kt-menu-placement='bottom-end'
            data-kt-menu-flip='top-end'
            onClick={(e) => { functionDownload() }}
            disabled ={isDownloadContinue}
          >
            {!isDownloadContinue && (
              <KTSVG
              path='/media/icons/duotune/arrows/arr044.svg'
              className='svg-icon-3'
              />
            )}
            {isDownloadContinue && (
              <span className='indicator-progress' style={{ display: 'block' }}>
                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
              </span>
            )}
          </button>
        </div>
      </div>
      {/* end::Header */}
      {/* begin::Body */}
      <div className='card-body py-3 scroll-y mh-450px maxh-md-600px'>
        <div className='tab-content'>
          {/* begin::Tap pane */}
          <div className='tab-pane fade show active' id='kt_table_widget_5_tab_1'>
            {/* begin::Table container */}
            <div className='table-responsive'>
              {/* begin::Table */}
              <table className='table table-row-dashed table-row-gray-200 align-middle gs-0 gy-2'>
                {/* begin::Table head */}
                <thead>
                  <tr className=''>
                    <th className=''>{LanguageHelp("Channel")}</th>
                    <th className=''>{LanguageHelp("Total")}</th>
                    <th className=''>{LanguageHelp("Positive")}</th>
                    <th className=''>{LanguageHelp("Negative")}</th>
                    <th className=''>{LanguageHelp("Neutral")}</th>
                    <th className=''></th>
                  </tr>
                </thead>
                {/* end::Table head */}
                {/* begin::Table body */}
                <tbody>
                  {datas.items.map((data, index) => (
                    <tr key={data.label}>
                      <td>
                        <div className='d-flex align-items-center'>
                          {/* begin:: Avatar */}
                          <div className='symbol symbol-50px overflow-hidden me-3'>
                            <a href={data.url + '&filter_subject=' + selectedOption + '&filter_channeltype=' + selectedChannelType + '&filter_date=' + selectedDate}>
                              <div className='symbol-label' style={{ backgroundColor: 'transparent' }}>
                                <img src={toAbsoluteUrl(data.image)} className='w-100' />
                              </div>
                            </a>
                          </div>
                          <div className='d-flex flex-column'>
                            <a href={data.url + '&filter_subject=' + selectedOption + '&filter_channeltype=' + selectedChannelType + '&filter_date=' + selectedDate} className='text-gray-800 text-hover-primary mb-1'>
                              {data.label}
                            </a>
                          </div>
                        </div>
                      </td>
                      <td className='text-dark fw-bold mb-1'>{data.firstCount}
                        <Rating rate={data.firstRate} />
                      </td>
                      <td className='text-dark fw-bold mb-1'>{data.secondCount}
                        <Rating rate={data.secondRate} />
                      </td>
                      <td className='text-dark fw-bold mb-1'>{data.thirdCount}
                        <Rating rate={data.thirdRate} reversed={true} />
                      </td>
                      <td className='text-dark fw-bold mb-1'>{data.fourthCount}
                        <Rating rate={data.fourthRate} />
                      </td>
                      <td className='text-end'>
                        <a href={data.url + '&filter_subject=' + selectedOption + '&filter_channeltype=' + selectedChannelType + '&filter_date=' + selectedDate} className='btn btn-sm btn-icon btn-bg-light btn-active-color-primary'>
                          <KTSVG path='/media/icons/duotune/arrows/arr064.svg' className='svg-icon-2' />
                        </a>
                      </td>
                    </tr>
                  ))}
                </tbody>
                {/* end::Table body */}
              </table>
            </div>
            {/* end::Table */}
          </div>
          {/* end::Tap pane */}
        </div>
      </div>
      {/* end::Body */}
    </div>
  )
}

export { TablesWidget5 }
